"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findInsuranceCompanyByOrgNoQuery = exports.findInsurancesCompanyByNameQuery = exports.queryInsuranceCompanies = void 0;
const finance_1 = require("../../types/finance");
exports.queryInsuranceCompanies = `
  query getInsuranceCompanies {
    insuranceCompanies {
      ${finance_1.insuranceFields}
    }
  }
`;
exports.findInsurancesCompanyByNameQuery = `
  query findInsurancesCompanyByName($name: String!) {
    findInsurancesCompanyByName(name: $name) {
      ${finance_1.insuranceFields}
    }
  }
`;
exports.findInsuranceCompanyByOrgNoQuery = `
  query findInsuranceCompanyByOrgNo($organizationNumber: String!) {
    findInsuranceCompanyByOrgNo(organizationNumber: $organizationNumber) {
      ${finance_1.insuranceFields}
    }
  }
`;
//# sourceMappingURL=insurance-companies.js.map